import { createStyles, ThemeIcon, Progress, Text, Group, Badge, Paper, Button } from '@mantine/core';
import { Music } from 'tabler-icons-react';

const ICON_SIZE = 60;

const useStyles = createStyles((theme) => ({
  card: {
    position: 'relative',
    overflow: 'visible',
    padding: theme.spacing.xl,
    paddingTop: theme.spacing.xl * 1.5 + ICON_SIZE / 3,
  },

  icon: {
    position: 'absolute',
    top: -ICON_SIZE / 3,
    left: `calc(50% - ${ICON_SIZE / 2}px)`,
  },

  title: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    lineHeight: 1,
  },
}));

//TODO: Props for title, track name, progress etc
export function TrendingGroupBuy() {
  const { classes } = useStyles();

  return (
    <Paper radius="md" withBorder className={classes.card} mt={ICON_SIZE / 3}>
      <ThemeIcon className={classes.icon} size={ICON_SIZE} radius={ICON_SIZE}>
        <Music size={34} />
      </ThemeIcon>

      <Text align="center" weight={700} className={classes.title}>
        Juice WRLD
      </Text>
      <Text color="dimmed" align="center" size="sm">Unreleased Track</Text>

      <Group position="apart" mt="xs">
        <Text size="sm" color="dimmed">Pledged</Text>
        <Text size="sm" color="dimmed">73%</Text>
      </Group>

      <Progress value={73} mt={5} />

      <Group position="apart" mt="md">
        <Text size="sm">$8,500 / $10,000</Text>
        <Button
          variant="filled"
          color="green"
          component="a"
        >Pledge</Button>
      </Group>
    </Paper>
  );
}